const SCANNER_STAGE_LABELS = ["SCAN", "FILTER", "SIGNAL_CREATED"];
const SIGNAL_STAGE_LABELS = ["SIGNAL_CREATED", "REVIEW", "INTENT", "SUBMITTED", "FILLED"];

const STATUS_CLASS = {
  waiting: "border-slate-200 bg-slate-50 text-slate-600",
  running: "border-cyan-200 bg-cyan-50 text-cyan-700",
  completed: "border-emerald-200 bg-emerald-50 text-emerald-700",
  blocked: "border-rose-200 bg-rose-50 text-rose-700",
  skipped: "border-amber-200 bg-amber-50 text-amber-700",
};

const normalizeStatus = (value) => {
  const normalized = String(value || "waiting").toLowerCase();
  if (Object.hasOwn(STATUS_CLASS, normalized)) return normalized;
  return "waiting";
};

export const UserPipelineStatusBar = ({ mode = "scanner", stages = {}, summary = null }) => {
  const normalizedMode = String(mode || "scanner").toLowerCase() === "signal" ? "signal" : "scanner";
  const labels = normalizedMode === "signal" ? SIGNAL_STAGE_LABELS : SCANNER_STAGE_LABELS;

  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={`user-pipeline-status-bar-${normalizedMode}`}>
      <div className="mb-3 flex items-center justify-between" data-testid={`user-pipeline-status-bar-${normalizedMode}-header`}>
        <h2 className="text-base font-semibold text-slate-900" data-testid={`user-pipeline-status-bar-${normalizedMode}-title`}>
          Pipeline ({normalizedMode === "scanner" ? "Scanner" : "Signal"} mode)
        </h2>
      </div>

      <div className={`grid gap-2 ${normalizedMode === "scanner" ? "md:grid-cols-3" : "md:grid-cols-5"}`} data-testid={`user-pipeline-status-bar-${normalizedMode}-stages`}>
        {labels.map((label) => {
          const stageData = stages?.[label] || {};
          const status = normalizeStatus(stageData?.status);
          const stageCount = Number(stageData?.count || 0);
          return (
            <article
              key={label}
              className={`rounded-xl border px-3 py-2 ${STATUS_CLASS[status]}`}
              data-testid={`user-pipeline-stage-${normalizedMode}-${label.toLowerCase()}`}
            >
              <p className="text-[11px] font-semibold tracking-wide" data-testid={`user-pipeline-stage-${normalizedMode}-${label.toLowerCase()}-label`}>{label}</p>
              <p className="text-sm font-semibold" data-testid={`user-pipeline-stage-${normalizedMode}-${label.toLowerCase()}-status`}>{status}</p>
              {normalizedMode === "signal" && (
                <p className="text-xs" data-testid={`user-pipeline-stage-${normalizedMode}-${label.toLowerCase()}-count`}>
                  count: {stageCount}
                </p>
              )}
            </article>
          );
        })}
      </div>

      {summary && (
        <div className="mt-3 rounded-xl border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700" data-testid={`user-pipeline-status-bar-${normalizedMode}-summary`}>
          {normalizedMode === "scanner" ? (
            <p data-testid="user-pipeline-status-bar-scanner-summary-text">
              {summary.scanned_count || 0} coin tarandı · {summary.filtered_count || 0} coin filtrelendi · {summary.signal_created_count || 0} sinyal üretildi
            </p>
          ) : (
            <p data-testid="user-pipeline-status-bar-signal-summary-text">
              detected={summary.detected_count || 0} · pending={summary.pending_count || 0} · blocked={summary.blocked_count || 0} · filled={summary.filled_count || 0}
            </p>
          )}
        </div>
      )}
    </section>
  );
};
